var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
import RevisioSvg from "assets/svg/revisio.svg";
import React from "react";
import { useTranslation } from "react-i18next";
import { Text } from "rebass";
import CollectionList from "src/components/blocks/CollectionList";
import { LinkButton } from "src/components/elements/Button";
import Title from "src/components/typography/Title";
import { Content } from "src/components/utilities/Containers";
import { REVISIO_HOME_LIMIT } from "src/queries/collections";
import { svgStyle } from "src/styles/helpers";
import styled from "styled-components";
var RevisioIcon = styled(RevisioSvg)(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  ", ";\n  height: 3.4rem;\n"], ["\n  ", ";\n  height: 3.4rem;\n"])), svgStyle);
var RevisioCollections = function (_a) {
    var results = _a.results, count = _a.count;
    var t = useTranslation().t;
    var collections = results.filter(function (c) { return c != null; });
    if (collections.length === 0)
        return null;
    return (React.createElement(Content, { mt: 3 },
        React.createElement(Title, { sm: true, icon: React.createElement(RevisioIcon, null) }, t("revisio.sectionTitle")),
        React.createElement(CollectionList, { data: collections, displayEarnablePoints: true, getCollectionPath: function (collection) { return "/series/".concat(collection.id, "/revisio"); } }),
        count > REVISIO_HOME_LIMIT && (React.createElement(Text, { pt: 1, textAlign: "center" },
            React.createElement(LinkButton, { to: "/mes-revisions", css: "width: 100%; max-width: 22rem;" }, t("revisio.seeMore"))))));
};
export default RevisioCollections;
var templateObject_1;
